import React from "react";

const ProductList = ({ products }) => {
    if (!products || products.length === 0) {
        return (
            <div className="text-center py-12">
                <p className="text-gray-500 text-lg font-medium">No products found.</p>
                <p className="text-gray-400 text-sm mt-2">Please check back later or adjust your search.</p>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4">
            {products.map((product) => (
                <div
                    key={product.id}
                    className="border border-gray-200 p-4 rounded-xl shadow-sm bg-white hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
                >
                    <img
                        src={product.imageUrl}
                        alt={product.name}
                        onError={(e) => {
                            e.currentTarget.src = `https://placehold.co/400x300/e0e0e0/333333?text=Image+Not+Found`;
                            e.currentTarget.onerror = null;
                        }}
                        className="w-full h-48 object-cover rounded-md mb-4 shadow-sm"
                    />
                    <h2 className="text-xl font-semibold text-gray-800 mt-2">{product.name}</h2>
                    <p className="text-sm text-gray-600 mt-1">
                        <span className="font-medium">Category:</span> {product.category}
                    </p>
                    <p className="text-sm text-gray-600">
                        <span className="font-medium">Material:</span> {product.material}
                    </p>
                    <p className="text-sm text-gray-600">
                        <span className="font-medium">Style:</span> {product.style}
                    </p>
                    {/* Price and Action buttons removed */}
                </div>
            ))}
        </div>
    );
};

export default ProductList;
